import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'internalFeeQuantity'
})
export class InternalFeeQuantityPipe implements PipeTransform {
  public transform(element: DepartmentEstimate | Category, internalResourceEstimateId?: string) {
    return element.estimateLines.reduce(
      (quantity, estimateLine) =>
        quantity +
        estimateLine.internalFeeLines
          .filter(
            i => i.internalResourceEstimateId === internalResourceEstimateId || internalResourceEstimateId == undefined
          )
          .map(i => i.quantity)
          .reduce((sumQty, qty) => sumQty + qty, 0),
      0
    );
  }
}
